import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
/**
 * 内部页面
 */

var HorizontalSlidePage =
/** @class */
function (_super) {
  __extends(HorizontalSlidePage, _super);

  function HorizontalSlidePage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  HorizontalSlidePage = __decorate([Component({
    name: 'HorizontalSlidePage'
  })], HorizontalSlidePage);
  return HorizontalSlidePage;
}(Vue);

export default HorizontalSlidePage;